import Cart from 'components/Cart/Cart';
import { UserTypesWithGuestEnum } from 'types/UserTypesWithGuestEnum';
import { MyCustomersHomeButton } from 'components/common/Buttons/MyCustomersHomeButton';
import { LogoutButton } from 'components/common/Buttons/LogoutButton';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import useUser from '../../../stores/useCustomer';
import useCustomerActions from '../../../hooks/useCustomerActions';
import MyAccountButton from '../../MyAccountButton';
import { LogInButton } from '../LogInButton';
import { FavouritesButton } from '../../FavouritesButton';

export function UserActions() {
    const user = useUser((state) => state.user);
    const { clickMyAccount, clickFavourites } = useCustomerActions();
    const { isGuestCheckoutEnabled } = useFeatureFlags();

    if (user && user.user_type === UserTypesWithGuestEnum.Consultant) {
        return (
            <>
                <MyCustomersHomeButton />
                <LogoutButton />
            </>
        );
    }

    if (user && (user.user_type === UserTypesWithGuestEnum.User || (isGuestCheckoutEnabled && user.user_type === UserTypesWithGuestEnum.Shopper))) {
        return (
            <>
                <Cart />
                <FavouritesButton onClick={clickFavourites} />
                <MyAccountButton onClick={clickMyAccount} />
            </>
        );
    }

    return (
        <>
            {isGuestCheckoutEnabled && <Cart />}
            <LogInButton />
        </>
    );
}
